import React from "react";

import { formatNumber, getVariance } from "utils";

import { Card, Col, MapInteractive, Typography } from "components";

export const CalculatedSize = ({ calculatedArea, calculatedGeometry, field, location, markers, setCalculatedArea, updateCalculatedMap }) => (
  <>
    <Col sm={24} md={12}>
      <Typography variant="h4">Calculated size</Typography>
      <Typography variant="paragraph-m">
        {calculatedArea ? formatNumber({ number: calculatedArea, decimalPlaces: 4 }) : 0}
        ha ({calculatedArea ? getVariance(field.size, calculatedArea, 2) : 0}% variance)
      </Typography>
      <Card className="map-card" id="staticMap">
        {calculatedGeometry && (
          <MapInteractive
            field={field}
            geometry={calculatedGeometry}
            location={location}
            markers={markers}
            onChange={updateCalculatedMap}
            scaleControl={true}
            updateArea={setCalculatedArea}
            zoomControl={true}
          />
        )}
      </Card>
    </Col>
  </>
);
